function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.893 18.393A8.147 8.147 0 0012 20.182c1.932 0 3.707-.67 5.107-1.79l-2.6-2.6a4.524 4.524 0 01-2.507.753 4.524 4.524 0 01-2.507-.753l-2.6 2.6zm-1.286-1.286l2.6-2.6A4.524 4.524 0 017.456 12c0-.926.277-1.788.753-2.507l-2.6-2.6A8.147 8.147 0 003.817 12c0 1.932.67 3.707 1.79 5.107zm10.185-7.614c.476.719.753 1.58.753 2.507 0 .926-.277 1.788-.753 2.507l2.6 2.6A8.147 8.147 0 0020.183 12c0-1.932-.67-3.707-1.79-5.107l-2.6 2.6zm-1.285-1.285l2.6-2.6A8.147 8.147 0 0012 3.817c-1.932 0-3.707.67-5.107 1.79l2.6 2.6A4.524 4.524 0 0112 7.455c.926 0 1.788.277 2.507.753zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-7.273a2.727 2.727 0 100-5.454 2.727 2.727 0 000 5.454z"
});

var SvgSupport = function SvgSupport(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/support.55d46687.svg";
export { SvgSupport as ReactComponent };